<template>
  <div>
    <com-dialog :visible.sync="visible" width="80%">
      <div>
        <com-table
          ref="table"
          :columns="tableColumns"
          :api="api"
          :default-params="defaultQuery"
          :run="false"
        >
          <template #startTime="{ data }">
            {{ data.startTime | timeFormate }}
          </template>
          <template #endTime="{ data }">
            {{ data.endTime | timeFormate }}
          </template>
          <template #duration="{ data }"> {{ data.duration }}min </template>
          <template #combo="row">
            <div v-if="!row.data.payPlan.autoStop">
              <div v-if="row.data.type === '2'">{{ row.data.payPlan.duration }}小时</div>
              <div v-else>{{ row.data.payPlan.sum }}元</div>
            </div>
            <div v-else>充满自停</div>
          </template>
          <template #type="row">
            {{ payType[row.data.type] }}
          </template>
          <template #status="row">
            {{ orderStatus[row.data.status] }}
          </template>
        </com-table>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { orderList } from '@/api/electric_card'
import { orderStatus, payTypes } from '@/json/common'

export default {
  data() {
    return {
      api: orderList,
      visible: false,
      orderStatus,
      payType: payTypes,
      tableColumns: [
        {
          label: '订单编号',
          prop: 'number'
        },
        {
          label: '二维码',
          prop: 'refDevSn'
        },
        {
          label: '设备号',
          prop: 'refDevLabel'
        },
        {
          label: '开始时间',
          prop: 'startTime',
          type: 'slot',
          slotName: 'startTime'
        },
        {
          label: '结束时间',
          prop: 'endTime',
          type: 'slot',
          slotName: 'endTime'
        },
        {
          label: '订单时长',
          prop: 'duration',
          type: 'slot',
          slotName: 'duration'
        },
        {
          label: '套餐',
          prop: 'combo',
          type: 'slot',
          slotName: 'combo'
        },
        {
          label: '订单金额',
          prop: 'paySum'
        },
        {
          label: '支付方式',
          prop: 'type',
          minWidth: '90',
          type: 'slot',
          slotName: 'type'
        },
        {
          label: '订单状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status',
          minWidth: '120',
          fixed: 'right'
        }
      ],
      defaultQuery: {
        cardNo: ''
      }
    }
  },
  methods: {
    open(row) {
      console.log('row :>> ', row)
      this.defaultQuery.cardNo = row.cardNo
      this.visible = true
      setTimeout(() => {
        this.$refs.table.init()
      }, 100)
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
